<template>

  <div
    class="card mb-4"
    :class="{'box-loading': loading}">
    <div class="card-body">

      <!--identificação da conexão-->
      <div class="d-flex align-items-center mb-3">
        <div class="mr-auto">
          <h5 class="mb-0">{{ provider.label }}</h5>
          <div
            v-if="email"
            class="subtext">{{ email }}</div>
        </div>
        <button
          type="button"
          class="btn btn-outline-danger"
          :disabled="loading"
          @click="remove()">{{ $t('Remove') }}</button>
      </div>

      <!--status da conexão (só depois que a sincronização começa)-->
      <ul
        v-if="syncStarted"
        class="list-group mb-4">
        <li class="list-group-item d-flex justify-content-between align-items-center">
          <span>{{ $t('Status') }}</span>
          <span
            class="badge"
            :class="statusClass">{{ statusLabel }}</span>
        </li>
        <li
          v-if="connection.status_detail"
          class="list-group-item subtext">
          {{ connection.status_detail }}
        </li>
        <li
          v-if="syncStatus"
          class="list-group-item d-flex justify-content-between align-items-center">
          <span>Sincronização</span>
          <span
            v-if="syncing"
            class="d-flex align-items-center">
            <span class="spinner-border spinner-border-sm mr-2" role="status">
              <span class="sr-only">Loading...</span>
            </span>
            Sincronizando...
          </span>
          <span
            v-else
            class="badge"
            :class="syncStatus === 'synced' ? 'badge-success' : 'badge-secondary'">{{ syncStatus }}</span>
        </li>
      </ul>
      <!--
      alerta do passo que falta. enquanto a agenda não é escolhida nada é
      sincronizado, então o aviso vem antes de qualquer outra informação
      -->
      <div
        v-else
        class="alert alert-warning d-flex align-items-center">
        <i class="fas fa-exclamation-triangle mr-3" />
        <div>
          <strong>Falta um passo para concluir</strong>
          <div>Escolha abaixo qual agenda você quer usar e inicie a sincronização. Até lá nada é enviado para o seu calendário.</div>
        </div>
      </div>

      <!--configuração da agenda-->
      <Page
        :connection="connection"
        @updated="$emit('updated')" />

    </div>
  </div>

</template>

<script>
import Page from './Page'

export default {
  name: 'ProfileCalendarConnection',
  components: {
    Page
  },
  props: {
    // item do array `providers` de ProfileCalendarSettings
    provider: {
      type: Object,
      required: true
    },
    connection: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    accountId () {
      return this.$store.getters.getAccount._id
    },
    // /profile/connections/calendar/:connection_id
    url () {
      return '/accounts/' + this.accountId + '/profile/connections/calendar/' + this.connection._id
    },
    // conta conectada no provedor
    email () {
      return this.connection.provider_unique_id || this.connection.name
    },
    statusLabel () {
      if (this.connection.status === 'active') return this.$t('Connected')
      if (this.connection.status === 'error') return this.$t('Error')
      return this.$t('Disconnected')
    },
    statusClass () {
      if (this.connection.status === 'active') return 'badge-success'
      if (this.connection.status === 'error') return 'badge-danger'
      return 'badge-secondary'
    },
    // a sincronização só existe depois que a agenda é escolhida
    syncStarted () {
      return !!(this.connection.connection_config || {}).calendar_id
    },
    // estado da sincronização da agenda (synced, syncing, ...)
    syncStatus () {
      return (this.connection.metadata || {}).sync_status
    },
    syncing () {
      return this.syncStatus === 'syncing'
    }
  },
  methods: {
    /*
    remove
    DELETE /profile/connections/calendar/:connection_id
    */
    remove () {
      const deleteAction = async () => {
        this.loading = true

        try {
          await this.axios.delete(this.url)
          this.$emit('removed')
        } catch (err) {
          console.log(err)
        } finally {
          this.loading = false
        }
      }

      this.$store.dispatch('setAlertModal', {
        action: deleteAction
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ProfileCalendarSettings/ProfileCalendarConnection.vue